import CONSTANTS from '../constants';

let state = {
    globalError: '',
    globalMsg: '',
    fichaInscricao: {
        respondeu: false,
        gravando: false,
        avd_nome: '',
        avd_msgi: '',
        avd_msgt: '',
        carregandoQuestoes: false,
        isMenorDeIdade: false,
        anjoLogado: null,
        listQuestoes: [],
        listRespostas: {},
    },
    solicitante: {
        carregandoLiberado: false,
        liberado: false,
        gravandoSolicitante: false,
        solTipo: 'J'.charCodeAt(0).toString(),
        solUF: 'SP',
        solUFProjeto: 'SP',
        carregandoCidades: false,
        listAreasSelecionadas: [],
        listAreas: [],
        listCidades: [],
        listCidadesProjeto: [],
        solCepProjeto: "",
        solBairroProjeto: "",
        solLocalProjeto: "",
        locCodProjeto: "",
        solContato: "",
        solPublico: "",
        solAcaoResp: "",
        solTecResp: "",
        solNumConselho: ""

    }
};



export default state;